import {
  CategoriesResponse,
  DeleteBulkCategoryResponse,
  PostCreateCategoryResponse,
  PutUpdateCategoryResponse,
} from 'types/APIResponsesTypes';
import { APIClient } from 'services/helpers/api_helper';
import * as url from 'services/helpers/url_helper';
import { CreateCategory, UpdateCategory } from 'types/category/categoryTypes';
import { AxiosResponse } from 'axios';

const api = new APIClient();

export const getCategories = async (
  store_ids: string,
  keyword = '',
  page = 1,
  limit = 50,
  sort_by = 'name',
  sort_order = 'asc'
) => {
  try {
    const response: Promise<CategoriesResponse> = await api.get(
      url.GET_CATEGORIES,
      {
        store_ids,
        keyword,
        page,
        limit,
        sort_by,
        sort_order,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postAddCategory = async (FormData: CreateCategory) => {
  try {
    const response: Promise<PostCreateCategoryResponse> = await api.create(
      url.POST_ADD_CATEGORY,
      FormData
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdateCategory = async (FormData: UpdateCategory) => {
  try {
    const response: Promise<PutUpdateCategoryResponse> = await api.put(
      url.PUT_UPDATE_CATEGORY,
      FormData
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteBulkCategory = async (categoryNumbers: number[]) => {
  try {
    const body = {
      category_numbers: categoryNumbers,
    };
    const response: AxiosResponse<DeleteBulkCategoryResponse> =
      await api.delete(url.DELETE_BULK_CATEGORY, {
        data: body,
      });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
